import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connectToggleRefinement, connectStateResults } from 'react-instantsearch-dom';
import { trackAlgoliaClickedFilter, trackFacetClick } from 'ck-utils/algoliaAnalytics';
import { CheckBox, Typography } from 'ck-ui';
import { generateFacetCombinations } from 'ck-utils';
import { FacetContainer } from './FacetContainer';
import { ProductListingPageContext } from '../context';

const Toggle = ({
  attribute,
  containerLabel,
  label,
  value,
  currentRefinement,
  count,
  refine,
  searchResults
}) => {
  const { searchState } = useContext(ProductListingPageContext);
  const refineToggle = () => {
    if (!currentRefinement) {
      trackAlgoliaClickedFilter({
        index: searchResults?.index,
        filters: [`${attribute}:${value}`]
      });
      trackFacetClick({
        facet_type: 'left_menu',
        facet_name: attribute,
        facet_value: value,
        facet_combinations: generateFacetCombinations(searchState, attribute)
      });
    }
    refine(!currentRefinement);
  };
  return count.unchecked <= 1 ? null : (
    <FacetContainer
      label={containerLabel}
      render={() => (
        <label className="facet-label">
          <CheckBox checked={currentRefinement} onChange={refineToggle}>
            {label}
          </CheckBox>
          &nbsp;<Typography display="inline">({count.unchecked})</Typography>
        </label>
      )}
    />
  );
};

Toggle.propTypes = {
  attribute: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  containerLabel: PropTypes.string.isRequired,
  currentRefinement: PropTypes.bool.isRequired,
  count: PropTypes.object.isRequired,
  refine: PropTypes.func.isRequired,
  searchResults: PropTypes.object,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
};

Toggle.defaultProps = {
  searchResults: null,
};

export const ToggleFacet = connectToggleRefinement(connectStateResults(Toggle));
